import React, { useState } from "react";
import { Settings, BatteryCharging, Wrench, Maximize2, X } from "lucide-react";

const CompatibilitySection = ({ navigateTo }) => {
  // Stav, který drží informace o momentálně zvětšeném obrázku
  const [selectedImage, setSelectedImage] = useState(null);

  const steps = [
    {
      title: "1. Středový motor",
      description:
        "Pasuje na 95 % všech jízdních kol. Motor se jednoduše zasune místo vašeho stávajícího středového složení (standardní šířka 68–73 mm).",
      icon: <Settings className="w-6 h-6 text-green-600" />,
      image: "/images/stred.png",
    },
    {
      title: "2. Výběr a pasování baterie",
      description:
        "Rámová baterie se montuje na místo košíku pro láhev a vyžaduje dostatek prostoru uvnitř rámu. Pokud máte rám menší nebo atypický, skvělou alternativou je baterie nosičová. K její instalaci stačí mít na kole běžné závity pro zadní nosič (má je naprostá většina kol). Pokud si nejste jisti výběrem, neváhejte nás kontaktovat!",
      icon: <BatteryCharging className="w-6 h-6 text-green-600" />,
      // OPRAVA: Tady je upravený název obrázku
      images: [
        { src: "/images/rambaterie.png", label: "Rámová" },
        { src: "/images/rambateriezad.png", label: "Nosičová" }
      ],
    },
    {
      title: "3. Snadná montáž",
      description:
        "Kabeláž je vybavena voděodolnými konektory, u kterých nehrozí špatné zapojení. Každý konektor je totiž tvarově jedinečný a navíc barevně odlišený, což maximálně usnadňuje montáž. Není potřeba nic pájet ani složitě nastavovat.",
      icon: <Wrench className="w-6 h-6 text-green-600" />,
      image: "/images/konektory.png",
    },
  ];

  // Funkce na zavření okna
  const handleClose = (e) => {
    e.stopPropagation();
    setSelectedImage(null);
  };

  return (
    <div className="bg-white py-16 md:py-24 border-b border-slate-100 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-extrabold text-[#2a3b4c]">
            Přestavba je jednodušší, než si myslíte
          </h2>
          <p className="text-slate-500 mt-4 text-lg max-w-2xl mx-auto">
            Nemusíte být profesionální mechanik. Vše je navrženo jako jednoduchá
            stavebnice, kterou zvládne složit každý.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-10">
          {steps.map((step, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl border border-slate-100 shadow-sm hover:shadow-xl transition-all duration-300 overflow-hidden group flex flex-col"
            >
              {/* OBLAST PRO OBRÁZEK S MOŽNOSTÍ KLIKNUTÍ */}
              <div className="h-56 w-full bg-slate-50 relative overflow-hidden flex items-center justify-center">
                <div className="absolute top-4 left-4 bg-white p-2 rounded-lg shadow-sm z-20 border border-slate-100">
                  {step.icon}
                </div>

                {step.images ? (
                  // Varianta se DVĚMA obrázky (Rámová + Nosičová)
                  <div className="w-full h-full flex items-center justify-between p-4 pt-8 gap-4">
                    {step.images.map((imgItem, imgIndex) => (
                      <div 
                        key={imgIndex}
                        className="w-1/2 h-full flex flex-col items-center justify-center relative cursor-pointer hover:scale-[1.05] transition-transform duration-300"
                        onClick={() => setSelectedImage(imgItem.src)}
                        title={`Zvětšit náhled: ${imgItem.label} baterie`}
                      >
                        <div className="absolute top-0 right-0 bg-white/90 p-1.5 rounded-lg shadow-sm z-10 opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-slate-500">
                          <Maximize2 className="w-3 h-3" />
                        </div>
                        <img
                          src={imgItem.src}
                          alt={imgItem.label}
                          className="max-h-full max-w-full object-contain mix-blend-multiply"
                          onError={(e) => { e.target.style.display = "none"; }}
                        />
                        <span className="absolute bottom-2 text-[10px] font-bold uppercase tracking-wider text-slate-600 bg-white/90 px-2 py-1 rounded shadow-sm border border-slate-100">
                          {imgItem.label}
                        </span>
                      </div>
                    ))}
                  </div>
                ) : (
                  // Varianta s JEDNÍM obrázkem (Motor / Montáž)
                  <div 
                    className="w-full h-full flex items-center justify-center p-6 cursor-pointer"
                    onClick={() => setSelectedImage(step.image)}
                  >
                    <div className="absolute top-4 right-4 bg-white/90 p-2 rounded-lg shadow-sm z-10 border border-slate-100 opacity-0 group-hover:opacity-100 transition-opacity duration-300 text-slate-500">
                      <Maximize2 className="w-4 h-4" />
                    </div>
                    <img
                      src={step.image}
                      alt={step.title}
                      className="max-h-full max-w-full object-contain mix-blend-multiply group-hover:scale-[1.03] transition-transform duration-500"
                      onError={(e) => { e.target.style.display = "none"; }}
                    />
                  </div>
                )}
              </div>

              {/* OBLAST PRO TEXT */}
              <div className="p-6 md:p-8 flex flex-col flex-grow text-left">
                <h3 className="text-xl font-bold text-[#2a3b4c] mb-3">
                  {step.title}
                </h3>
                <p className="text-slate-500 leading-relaxed text-sm md:text-base">
                  {step.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-16 text-center">
          <button
            onClick={() => {
              if (navigateTo) navigateTo("guides");
            }}
            className="inline-flex items-center justify-center gap-2 px-8 py-4 bg-slate-100 hover:bg-slate-200 text-[#2a3b4c] font-bold rounded-xl transition-colors"
          >
            <Wrench className="w-5 h-5" />
            Podívat se na detailní návody k montáži
          </button>
        </div>
      </div>

      {/* --- VYSKAKOVACÍ OKNO PRO ZVĚTŠENÍ OBRÁZKU --- */}
      {selectedImage && (
        <div 
          className="fixed inset-0 z-[100] bg-slate-900/95 flex items-center justify-center p-4 backdrop-blur-sm cursor-zoom-out"
          onClick={handleClose} // Zavře se kliknutím na pozadí
        >
          <div className="relative max-w-5xl max-h-screen flex flex-col items-center justify-center w-full h-full">
            <button 
              className="absolute top-4 right-4 md:top-8 md:right-8 z-50 bg-white/20 hover:bg-white/40 text-white p-3 rounded-full transition-colors cursor-pointer shadow-lg"
              onClick={handleClose} // Zavře se kliknutím na křížek
              aria-label="Zavřít"
            >
              <X className="w-8 h-8" />
            </button>
            <img 
              src={selectedImage} 
              alt="Zvětšený náhled" 
              className="w-full h-full object-contain drop-shadow-2xl cursor-default rounded-xl relative z-40 bg-white p-4"
              onClick={(e) => e.stopPropagation()} // Zabrání zavření při kliknutí na samotný obrázek
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default CompatibilitySection;